import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a1c10dd2&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1c10dd2')) {
      api.createRecord('a1c10dd2', component.options)
    } else {
      api.reload('a1c10dd2', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a1c10dd2&", function () {
      api.rerender('a1c10dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4MnTIMwz9AyeA/JS/comp/ImgFallback.vue"
export default component.exports